module.exports = __webpack_public_path__ + "static/media/cat-post-1.ab3d073e.jpg";